import { TravelMerchandiserDedicatedReportActionTypes, TravelMerchandiserDedicatedReportState, READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_REQUEST, READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_SUCCESS, READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_FAILURE } from "store/reducers/types/dashboard/travelMerchandiserDedicatedReport";

const defaultState: TravelMerchandiserDedicatedReportState = {
  isLoading: false,
  errorMessage: "",
};

export default function travelMerchandiserDedicatedReport(state = defaultState, action: TravelMerchandiserDedicatedReportActionTypes): TravelMerchandiserDedicatedReportState {
  switch (action.type) {
    case READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
